import { useState } from "react";
import {
  anhbia,
  banhtieu,
  bbchay,
  bbchien,
  thapcam,
  trungcut,
  trungmuoi,
  xaxiu,
  xxphomai,
} from "./assets";

const products = [
  {
    id: 1,
    name: "Bánh Bao Trứng Cút",
    price: 15000,
    tag: "Best Seller",
    tagColor: "#e63946",
    image: trungcut,
    desc: "Nhân gồm trứng cút béo bùi, thịt heo xay đậm đà kết hợp cùng nấm và rau củ tươi. Vỏ bánh mềm mịn, thơm nhẹ, mang đến hương vị hài hòa, ăn một lần là nhớ mãi.",
    ingredients: ["Trứng cút", "Thịt heo xay", "Rau củ quả"],
  },
  {
    id: 2,
    name: "Bánh Bao Trứng Muối",
    price: 20000,
    tag: "Mới",
    tagColor: "#f4a261",
    image: trungmuoi,
    desc: "Nhân béo ngậy với trứng muối vàng ươm, thịt heo và rau củ quả. Vị mặn ngọt hài hòa, tan chảy trong miệng.",
    ingredients: ["Trứng muối", "Thịt heo", "Rau củ quả"],
  },
  {
    id: 3,
    name: "Bánh Bao Thập Cẩm",
    price: 25000,
    tag: "Best Seller",
    tagColor: "#e63946",
    image: thapcam,
    desc: "Nhân thập cẩm truyền thống: thịt heo xay, trứng cút, trứng muối, lạc xưởng, rau củ quả. Vỏ bánh mềm mịn, hấp chín tới.",
    ingredients: [
      "Thịt heo",
      "Trứng cút",
      "Trứng muối",
      "Lạc xưởng",
      "Rau củ quả",
    ],
  },
  {
    id: 4,
    name: "Bánh Bao Xúc Xích Phô Mai",
    price: 20000,
    tag: "Mới",
    tagColor: "#f4a261",
    image: xxphomai,
    desc: "Nhân xúc xích đậm vị kết hợp cùng phô mai kéo sợi béo ngậy và bắp ngọt tự nhiên. Vỏ bánh mềm mịn, nóng hổi, cắn một miếng là kéo sợi cực đã.",
    ingredients: ["Xúc xích", "Phô mai kéo sợi", "Bắp ngọt"],
  },
  {
    id: 5,
    name: "Bánh Bao Xá Xíu",
    price: 25000,
    tag: "Đặc biệt",
    tagColor: "#c1121f",
    image: xaxiu,
    desc: "Nhân xá xíu kiểu Quảng Đông: thịt heo nướng đỏ, sốt hoisin đậm đà. Hương vị đặc trưng, chuẩn vị Hoa.",
    ingredients: ["Xá xíu", "Sốt hoisin", "Rau củ quả"],
  },
  {
    id: 6,
    name: "Bánh Bao Chiên Giòn",
    price: 7000,
    tag: "Giòn rụm",
    tagColor: "#e9a010",
    image: bbchien,
    desc: "Vỏ ngoài chiên vàng giòn rụm, nhân thịt heo băm và rau củ. Ăn kèm tương ớt chua ngọt cực kỳ hấp dẫn.",
    ingredients: ["Thịt heo băm", "Rau củ quả", "Trứng cút"],
  },
  {
    id: 7,
    name: "Bánh Tiêu",
    price: 5000,
    tag: "Giòn rụm",
    tagColor: "#e9a010",
    image: banhtieu,
    desc: "Bánh tiêu chiên vàng giòn, bên ngoài phủ mè thơm lừng, bên trong mềm xốp, ngọt nhẹ. Ăn nóng cực ngon, thích hợp cho bữa xế hoặc ăn vặt.",
    ingredients: ["Bột mì", "Mè", "Đường", "Dầu ăn"],
  },
  {
    id: 8,
    name: "Bánh Bao Chay",
    price: 20000,
    tag: "Đặt trước",
    tagColor: "#2a9d8f",
    image: bbchay,
    desc: "Nhân chay thanh đạm: sườn non chay, rau củ quả, các loại nấm. Phù hợp ngày rằm và người ăn chay.",
    ingredients: ["Sườn non chay", "Rau củ quả", "Nấm"],
  },
];

function formatPrice(p: number) {
  return p.toLocaleString("vi-VN") + "đ";
}

export default function App() {
  const [active, setActive] = useState<number | null>(null);
  const [imgError, setImgError] = useState<Record<number, boolean>>({});

  return (
    <div
      style={{
        fontFamily: "'Segoe UI', sans-serif",
        background: "#fdf6ec",
        minHeight: "100vh",
      }}
    >
      {/* HEADER */}
      <div style={{ position: "relative", overflow: "hidden" }}>
        <img
          src={anhbia}
          alt="Bánh Bao Tư Lợi"
          style={{
            width: "100%",
            display: "block",
            maxHeight: 500,
            objectFit: "cover",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: 60,
            background: "linear-gradient(to bottom, transparent, #fdf6ec)",
          }}
        />
      </div>

      {/* SUBTITLE */}
      <div style={{ textAlign: "center", padding: "18px 16px 4px" }}>
        <div
          style={{
            display: "inline-block",
            background: "linear-gradient(135deg, #c1121f, #e63946)",
            color: "#fff",
            fontSize: 13,
            fontWeight: 700,
            letterSpacing: 2,
            padding: "5px 20px",
            borderRadius: 20,
            textTransform: "uppercase",
          }}
        >
          🥟 Thực đơn
        </div>
        <p
          style={{ color: "#888", fontSize: 13, marginTop: 8, marginBottom: 0 }}
        >
          Bánh hấp tươi mỗi ngày – đặt là có, ăn là mê, thử là nghiện
        </p>
      </div>

      {/* GRID */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(290px, 1fr))",
          gap: 18,
          padding: "20px 20px 40px",
          maxWidth: 960,
          margin: "0 auto",
        }}
      >
        {products.map((p) => {
          const isOpen = active === p.id;
          return (
            <div
              key={p.id}
              onClick={() => setActive(isOpen ? null : p.id)}
              style={{
                background: "#fff",
                borderRadius: 18,
                boxShadow: isOpen
                  ? "0 8px 32px rgba(198,18,28,0.18)"
                  : "0 2px 12px rgba(0,0,0,0.08)",
                cursor: "pointer",
                transition: "box-shadow 0.2s, transform 0.15s",
                transform: isOpen ? "translateY(-3px)" : "none",
                border: isOpen ? "2px solid #e63946" : "2px solid transparent",
                overflow: "hidden",
              }}
            >
              {/* Food Image */}
              <div
                style={{
                  position: "relative",
                  height: 180,
                  overflow: "hidden",
                  background: "#ffecd2",
                }}
              >
                {!imgError[p.id] ? (
                  <img
                    src={p.image}
                    alt={p.name}
                    onError={() =>
                      setImgError((prev) => ({ ...prev, [p.id]: true }))
                    }
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                      transition: "transform 0.4s ease",
                      ...(isOpen ? { transform: "scale(1.06)" } : {}),
                    }}
                  />
                ) : (
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 52,
                    }}
                  >
                    🥟
                  </div>
                )}

                {/* Tag badge over image */}
                <span
                  style={{
                    position: "absolute",
                    top: 10,
                    right: 10,
                    background: p.tagColor,
                    color: "#fff",
                    fontSize: 11,
                    fontWeight: 700,
                    padding: "4px 12px",
                    borderRadius: 20,
                    letterSpacing: 0.5,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                  }}
                >
                  {p.tag}
                </span>
              </div>
              {/* Card info */}
              <div style={{ padding: "14px 18px 4px" }}>
                <div
                  style={{
                    fontSize: 16,
                    fontWeight: 800,
                    color: "#1a1a1a",
                    lineHeight: 1.3,
                  }}
                >
                  {p.name}
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      marginTop: 6,
                      fontSize: 22,
                      fontWeight: 900,
                      color: "#c1121f",
                      letterSpacing: -0.5,
                    }}
                  >
                    {formatPrice(p.price)}
                  </div>
                  <span style={{ fontSize: 12, color: "#aaa" }}>
                    {isOpen ? "▲ Thu gọn" : "▼ Xem chi tiết"}
                  </span>
                </div>
              </div>
              {/* Expandable details */}
              <div
                style={{
                  maxHeight: isOpen ? 220 : 0,
                  overflow: "hidden",
                  transition: "max-height 0.35s ease",
                }}
              >
                <div style={{ padding: "10px 18px 14px" }}>
                  <p
                    style={{
                      fontSize: 13.5,
                      color: "#555",
                      lineHeight: 1.6,
                      margin: "0 0 12px",
                    }}
                  >
                    {p.desc}
                  </p>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                    {p.ingredients.map((ing) => (
                      <span
                        key={ing}
                        style={{
                          background: "#fff5e6",
                          border: "1px solid #f4a261",
                          color: "#c1121f",
                          fontSize: 11.5,
                          fontWeight: 600,
                          padding: "3px 10px",
                          borderRadius: 20,
                        }}
                      >
                        {ing}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* FOOTER */}
      <div
        style={{
          background: "linear-gradient(135deg, #c1121f, #9b1a22)",
          color: "#fff",
          textAlign: "center",
          padding: "22px 16px",
          fontSize: 13,
          lineHeight: 2,
        }}
      >
        <div style={{ fontWeight: 800, fontSize: 16, marginBottom: 4 }}>
          🥟 Bánh Bao Tư Lợi
        </div>
        <div>
          Đại chỉ: 36-38 Hẻm số 63, Tân Mai, Thành phố Biên Hòa, Đồng Nai, Việt
          Nam &nbsp;|&nbsp; 🛵 Giờ mở cửa từ 6:00 – 21:00
        </div>
        <div style={{ fontWeight: 800, color: "#f67878" }}>
          Đặt bánh liên hệ địa chỉ trên.
        </div>
        <div style={{ opacity: 0.7, marginTop: 4 }}>
          Bánh hấp tươi mỗi ngày, không dùng chất bảo quản
        </div>
      </div>
    </div>
  );
}
